module.exports = __webpack_public_path__ + "static/media/1.8d8a36d0.jpg";